module.exports = __webpack_public_path__ + "img/sb11.41349a85.png";